package dev.kuml.portal.web.editor

import dev.kuml.portal.web.i18n.strings.EditorStrings

/**
 * R-24: reine Zustandslogik des "DSL anzeigen"-Panels. Bewusst als eigenes, DOM-freies Objekt --
 * `kuml-portal-web` hat keine DOM-Tests, aber diese Verzweigungen (wann muss nachgeladen werden,
 * welcher Ersatztext gilt) sind genau die, die im Bug gefehlt haben, und sind so unit-testbar.
 *
 * R-18: the copy itself now comes from an [EditorStrings] parameter (never read a global `t`
 * internally -- this object stays a pure, language-agnostic function of its inputs, so both
 * languages remain independently unit-testable, see this wave's plan §5.7).
 */
public object DslPanelState {
    public fun loading(strings: EditorStrings): String = strings.dslLoading

    public fun empty(strings: EditorStrings): String = strings.dslEmpty

    public fun error(strings: EditorStrings): String = strings.dslError

    public fun toggleLabel(
        expanded: Boolean,
        strings: EditorStrings,
    ): String = if (expanded) strings.dslToggleExpanded else strings.dslToggleCollapsed

    /** `true`, wenn das Panel offen ist und kein Inhalt im Cache liegt (`null` = nie geladen bzw.
     * durch einen serverseitigen Diagrammwechsel invalidiert). */
    public fun needsFetch(
        expanded: Boolean,
        cached: String?,
    ): Boolean = expanded && cached == null
}
